// @ts-strict-ignore
import React from 'react'
import classNames from 'classnames'
import { IonItem, IonLabel, IonGrid, IonRow } from '@ionic/react'
import Button from '../../../common/components/Button'

import classnames from 'classnames'
import { SectionSocialGroupContainer as Container } from 'mytours-read-common'

import { getDirMode } from '../../../platform'
import { getSocialLink, getSocialLinkTitle, linksData } from '../../functions'

import '../styles/sectionGroup.less'

class SectionSocialGroup extends React.PureComponent<Container.Props & Container.Actions> {
	renderIcons = sectionItems => (
		<IonGrid
			className={classNames('block-content section-group-list ', getDirMode())}
			dir={getDirMode()}
			data-cy="story-screen-section-content"
		>
			{sectionItems.map((item: any) => {
				const data = linksData[item.social_network]
				if (!data) {
					return null
				}

				return (
					<Button
						key={item.id}
						href={getSocialLink(item.url || item.username, data.link)}
						className="item button-item"
						fill="clear"
						target="_blank"
						aria-label={item.link_text || getSocialLinkTitle(item.social_network, item.username) || ''}
					>
						<div className="icon-wrapper">
							<i className={classNames('brand-icon', data.icon)} />
						</div>
						{/* Not sure if this is needed here */}
						{/* {sectionItems.length === 1 && <IonText>{getSocialLinkTitle(item.social_network, item.username)}</IonText>} */}
					</Button>
				)
			})}
		</IonGrid>
	)

	renderList = sectionItems => (
		<IonGrid
			className={classNames('block-content section-group-list ', getDirMode())}
			dir={getDirMode()}
			data-cy="story-screen-section-content"
		>
			{sectionItems.map((item: any) => {
				const data = linksData[item.social_network]
				if (!data) {
					return null
				}

				return (
					<IonItem key={item.id} href={getSocialLink(item.url || item.username, data.link)} target="_blank">
						<div className="icon-wrapper">
							<i className={classNames('brand-icon', data.icon, getDirMode())} />
						</div>
						<IonLabel className="text-label">
							{item.link_text || getSocialLinkTitle(item.social_network, item.username)}
						</IonLabel>
					</IonItem>
				)
			})}
		</IonGrid>
	)

	render = () => {
		const {
			section: { layout, title, section_items: sectionItems },
		} = this.props

		const Wrap = ({ children }) => (
			<IonGrid
				className={classNames('section-group', { 'list-layout': layout === 'list', 'icon-layout': layout === 'icons' })}
			>
				<IonRow className="block-header">
					<h2 className={classnames('subheading', getDirMode())} data-cy="story-screen-section-heading">
						{title}
					</h2>
				</IonRow>
				{children}
			</IonGrid>
		)

		if (layout === 'icons') {
			return <Wrap>{this.renderIcons(sectionItems)}</Wrap>
		} else if (layout === 'list') {
			return <Wrap>{this.renderList(sectionItems)}</Wrap>
		}

		return null
	}
}

const SectionSocialGroupComponent = Container.default(SectionSocialGroup)
export default SectionSocialGroupComponent
